import { useCallback } from 'react'
import { ActivityPart } from '@/api/models/activityParts'
import { ActivityWithAggregate } from '@/api/models/aggregate'
import { lastActivityWorkFlowInfo } from '@/components/ActivityViewers/ltiArticleViewer/ActivityButtons/hooks/lastActivityWorkFlowInfo'
import { useHasAccessContentAfterCompletion } from '@/hooks/useHasAccessContentAfterCompletion'
import { useIsObjectiveWorkflowFinished } from '@/hooks/useIsObjectiveWorkflowFinished'

export const useIsNotAccessibleActivityPart = () => {
  const hasAccessContentAfterCompletion = useHasAccessContentAfterCompletion()
  const isObjectiveWorkflowFinished = useIsObjectiveWorkflowFinished()

  return useCallback(
    (activityPart: ActivityPart<ActivityWithAggregate>) => {
      const { activityWorkFlow } = lastActivityWorkFlowInfo(activityPart)

      // if objective is finished
      // and there is no activityWorkflow for activityPart, it means this content added after objective completion

      // so if that hasAccessContentAfterCompletion is false, we should not allow access to this content
      // if that hasAccessContentAfterCompletion is true, we should allow access to this content even after objective completion
      const isNotAccesible = !activityWorkFlow && !hasAccessContentAfterCompletion && isObjectiveWorkflowFinished

      return isNotAccesible
    },
    [hasAccessContentAfterCompletion, isObjectiveWorkflowFinished],
  )
}
